import { render } from "./FileUpload.vue?vue&type=template&id=4c2d71df&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=4c2d71df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2d71df"],['__file',"src/views/EnquiryForm/FileUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c2d71df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c2d71df', __exports__)) {
    api.reload('4c2d71df', __exports__)
  }
  
  module.hot.accept("./FileUpload.vue?vue&type=template&id=4c2d71df&scoped=true", () => {
    api.rerender('4c2d71df', render)
  })

}


export default __exports__